import { CSSProperties } from 'react'

export const s = {
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    padding: '15px 10px 15px',
  } as CSSProperties,
  result: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  } as CSSProperties,
  confirmFooter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  } as CSSProperties,
  modal: {
    height: 300,
    width: '100%',
  },
  title: {
    fontSize: 24,
  },
  text: {
    fontSize: 16,
  },
}
